import OfferService from "../../services/offer.service";
import BasketService from "../../services/basket.service";
import _ from "lodash";

const state = {
  offers: [],

  companyList: [],
  contactList: [],
  chartList: [],
  dealmakerList: [],
  guids: new Set(),
  dirtyHackValue: 0,
};

function setDates(offer) {
  offer.offerDate = new Date(offer.offerDate);
  if (_.has(offer, "createDate") && !_.isEmpty(offer.createDate)) {
    offer.createDate = new Date(offer.createDate);
  } else {
    _.set(offer, "createDate", new Date(0));
  }
  if (_.has(offer, "updateDate") && !_.isEmpty(offer.updateDate)) {
    offer.updateDate = new Date(offer.updateDate);
  } else {
    _.set(offer, "updateDate", new Date(0));
  }
}

const mutations = {
  setOffers(context, offers) {
    offers.forEach((offer) => {
      setDates(offer);
    });

    state.offers = [...offers];
  },
  updateOffer(state, offer) {
    _.remove(state.offers, {id: offer.id});
    setDates(offer);

    state.offers.push(offer);
  },
  deleteOffer(state, offer) {
    _.remove(state.offers, {id: offer.id});
    state.offers = [...state.offers];
  },
  deleteChartItem(context, id) {
    state.chartList = state.chartList.filter(
      (value) => value.basemasterGUID !== id
    );
    state.guids.delete(id);
    state.dirtyHackValue++;
  },
  addToOffer(state, input) {
    if (!state.guids.has(input.basemasterGUID)) {
      state.chartList.push(input);
      state.guids.add(input.basemasterGUID);
      state.dirtyHackValue++;
    }
  },
  setCompanyList(state, input) {
    state.companyList = input;
  },
  setContactList(state, input) {
    state.contactList = input;
    console.log(JSON.stringify(input));
  },
  loadDealMakers(state, input) {
    state.dealmakerList = input;
  },
  clearBasket(state) {
    state.chartList = [];
    state.guids.clear();
    state.dirtyHackValue++;
  }
};

const getters = {
  getOffers: (state) => {
    return _.orderBy(
      state.offers,
      ["updateDate", "createDate"],
      ["desc", "desc"]
    );
  },
  getChartList: (state) => {
    return state.chartList;
  },
  getCompanyList: (state) => {
    return state.companyList.content;
  },
  getContactList: (state) => {
    return state.contactList;
  },
  getChartCount: (state) => {
    return state.chartList.length;
  },
  getDealMakers: (state) => {
    return state.dealmakerList;
  },
  getDealMakerName: (state) => (dealMakerId) => {
    const dm = _.find(state.dealmakerList, {id: dealMakerId});
    if (dm) {
      return _.get(dm, "user", "");
    } else {
      return "";
    }
  },
  getSet: (state) => {
    return state.guids;
  },
  getHasItem: (state) => (id) => {
    return state.guids.has(id);
  },
  getDirtyHackValue: (state) => {
    return state.dirtyHackValue;
  },
};

const actions = {
  loadOffers(context) {
    return new Promise((resolve) => {
      BasketService.loadOffers().then((r) => {
        context.commit("setOffers", r.data);
        resolve(r.data);
      });
    });
  },
  saveOffer(context, offer) {
    return new Promise((resolve, reject) => {
      BasketService.createOffer(offer)
        .then((r) => {
          context.commit("updateOffer", r.data);
          resolve(r.data);
        })
        .catch(() => reject());
    });
  },
  deleteOffer(context, offer) {
    return new Promise((resolve) => {
      BasketService.deleteOffer(offer).then(() => {
        context.commit("deleteOffer", offer);
        resolve();
      })
    })
  },

  loadCompanies(context, query) {
    OfferService.findCompanies(query).then((r) => {
      let res = r.data;
      for (let c of res.content) {
        if (!c.name) {
          c['name'] = "< - >"
        }
      }
      // res.sort((a, b) => a.name.localeCompare(b.name));
      context.commit("setCompanyList", res);
    });
  },
  loadContactPersons(context, company) {
    if (company == null) {
      context.commit("setContactList", []);
    } else {
      OfferService.findContactPersonByCompany(company.id).then((r) => {
        context.commit("setContactList", r.data);
      });
    }
  },
  addToOffer(context, object) {
    context.commit("addToOffer", object);
  },
  deleteChartItem(context, index) {
    context.commit("deleteChartItem", index.basemasterGUID);
  },
  loadDealMakers(context) {
    OfferService.findDealMakers().then((r) => {
      context.commit("loadDealMakers", r.data);
    });
  },
  clearBasket(context) {
    context.commit("clearBasket");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
